/** WeekRow — 1:1 port z dashboard.jsx.
 *  7 buněk: day(70px) · time(60px) · klient · system · value(110px) · status(130px) · chevron(28px). */

import { fmtEur } from "@/lib/format";
import { Ic } from "./icons";
import { StatusBadge } from "./badge";
import { orderStatusMeta } from "@/lib/status";

export interface WeekRowItem {
  orderNr: string;
  day: string;
  date: string;
  time?: string | null;
  client: string;
  city: string;
  system: string;
  maker?: string;
  value: number;
  status: string;
}

export interface WeekRowProps {
  item: WeekRowItem;
  onOpen?: (it: WeekRowItem) => void;
  dense?: boolean;
}

export function WeekRow({ item, onOpen, dense = false }: WeekRowProps) {
  return (
    <tr
      className={onOpen ? "row-clickable" : undefined}
      onClick={onOpen ? () => onOpen(item) : undefined}
    >
      <td
        style={{
          width: 70,
          color: "var(--text-2)",
          fontSize: 12,
          paddingRight: 0,
        }}
      >
        <span
          style={{
            fontWeight: 600,
            color: "var(--text)",
            marginRight: 6,
          }}
        >
          {item.day}
        </span>
        {item.date}
      </td>
      <td className="num" style={{ width: 60, color: "var(--text-2)" }}>
        {item.time || ""}
      </td>
      <td>
        <div style={{ fontWeight: 500 }}>{item.client}</div>
        <div style={{ fontSize: 12, color: "var(--text-3)" }}>{item.city}</div>
      </td>
      <td style={{ color: "var(--text-2)" }}>
        <div>{item.system}</div>
        {!dense && item.maker && (
          <div style={{ fontSize: 11.5, color: "var(--text-3)" }}>{item.maker}</div>
        )}
      </td>
      <td className="right num" style={{ width: 110, fontWeight: 500 }}>
        {fmtEur(item.value)}
      </td>
      <td style={{ width: 130 }}>
        <StatusBadge meta={orderStatusMeta(item.status)} />
      </td>
      <td style={{ width: 28, color: "var(--text-3)" }}>
        <Ic.Chevron size={14} />
      </td>
    </tr>
  );
}
